
import ConstantVar from "@/Service/constant-var.js";
/*
* sb = success message in frontend
* cf = confirm message in frontend
* if = info message in frontend
* wf = warning message in frontend
* ef = error message in frontend
*/
export function msg_code(code) {
    var con_var = new ConstantVar();
    var message_code = {
        cf001: "Are you sure to Reset Password of User ID ",
        cf002: "Are you sure to Delete of User ID ",
        cf003: "Are you sure to Delete of Job Type ",
        cf004: "Are you sure to Delete the data of ",
        cf005: "Are you sure to Delete Job Transacion data?",
        cf006: "Are you sure to Delete this Applicant?",
        cf007: "Are you sure to Restore Deleted Applicant?",
        cf008: "Are you sure to Cancel? Current data will be gone and can not be Restore.",
        cf009: "Files is already exits. Do you want to overwrite it?",
        cf010: "Are you sure to Delete the file?",
        cf011: "Are you sure to Delete the file? It can be Permanently Delete in Server and cannot be Restore.",
        cf012: "Are you sure to overwrite the Profile? If yes, that will be confirmed after clicking the Update Button.",
        cf013: "Are you sure to Restore Deleted User ID ",
        cf014: "Are you sure to want Add New?  Current data will be gone and can not be Restore.",
        cf015: "Are you sure to delete?",
        if001: "No records found to download!",
        if002: "No matching records found",
        wf001: "Please select the applicant to download CV!",
        wf002: "Please select maximum "+con_var.MAX_DOWNLOAD+" applicants for downloading CV!",
        wf003: "Please select the applicant to set interview!",
        wf004: "Please select the applicant to delete!",
        wf005: "Please enter a valid User ID.",
        wf006: "Please enter a valid Email address.",
        wf007: "File is not Found. Someone is Deleted or Updated this File. Please confirm it.",
        wf008: "If you do not choose the New Profile, the Old one will be Remained Unchanged.",
        wf009: "Your file exceeds the Limit Allowed. Please select again.",
        wf010: "Your file exceeds the Limit allowed. These files will not be Selected.",
        wf011: "New password and confirm password do not match.",
        wf012: "Please enter valid user!",
        wf013: "You cannot change password!",
        wf014: "Session Timeout.",
        wf015: "At first please enter Name and Date of Birth in Correct Format.",
        wf016: "You cannot change another user's password.",
        ef001: "Logic error."
    };
    return message_code[code];
}